import React from 'react'
import { Outlet } from 'react-router-dom'
import NavigationBar from '../Navigation/NavigationBar'
import Footer from '../Footer/Footer'
import Seo from '../../seo/Seo'
import LocalBusinessJsonLd from '../../seo/LocalBusinessJsonLd'

const RootLayout = () => {
  return (
    <React.Fragment>
      <Seo />
      <LocalBusinessJsonLd />
      <NavigationBar />
      <Outlet />
      <Footer />
    </React.Fragment>
  )
}

export default RootLayout